import { useSetAtom } from 'jotai'
import React from 'react'

import { HStack } from '~/components/elements/HStack'
import {
  TooltipButton,
  type TooltipButtonProps,
} from '~/components/elements/TooltipButton'
import { type CustomerAttributeGroup } from '~/hooks/useSurveyQuery'

import { dialogInfoAtom } from '../atoms'

export type NameCellProps = {
  dataItem: CustomerAttributeGroup
}

export const NameCell = ({
  dataItem: customerAttributeGroup,
}: NameCellProps) => {
  const setDialogInfo = useSetAtom(dialogInfoAtom)
  const handleEditButtonClick = React.useCallback<
    EH<TooltipButtonProps, 'onClick'>
  >(() => {
    setDialogInfo({ dialogType: 'update', customerAttributeGroup })
  }, [customerAttributeGroup, setDialogInfo])

  return (
    <td>
      <HStack
        align="center"
        backgroundColor="transparent"
        justify="space-between"
        spacing={2}
      >
        <span>{customerAttributeGroup.name}</span>

        <TooltipButton
          fillMode="flat"
          icon="edit"
          title="Edit"
          onClick={handleEditButtonClick}
        />
      </HStack>
    </td>
  )
}
